module.exports = __webpack_public_path__ + "static/media/StartBackgroundFrame.c83fbaf2.svg";